import { Component, OnInit, Directive, ChangeDetectorRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { GenericBulkUpsertService } from '../services/generic-bulk-upsert.service';
import { GenericValidateResponse, GenericUploadResponse, GenericBulkUpsertField } from '../models/generic-bulk-upsert.model';
import { GenericBulkUpsertFeatureState, GenericBulkUpsertState, getGenericBulkUpsertFeatureState, getGenericBulkUpsertState } from '../store';
import { ResetState, ValidateFile, UploadFile } from '../store/actions/generic-bulk-upsert.actions';

@Directive()
export abstract class GenericBulkUpsertLandingComponent implements OnInit {
  protected _alive = true;

  vm$: Observable<GenericBulkUpsertState>;
  vm: GenericBulkUpsertState;

  selectedFile: File | null = null;
  showConfirmModal = false;
  
  abstract title: string;
  abstract validateEndpoint: string;
  abstract uploadEndpoint: string;
  abstract fields: GenericBulkUpsertField[];
  abstract templateFilename: string;

  constructor(
    protected store: Store<GenericBulkUpsertFeatureState>, 
    protected cdr: ChangeDetectorRef,
    protected genericService: GenericBulkUpsertService
  ) {
    this.vm$ = this.store.pipe(select(getGenericBulkUpsertState));
  }

  ngOnInit(): void {
    this.vm$.subscribe(vm => {
      this.vm = vm;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this._alive = false;
    this.cdr.detach();
  }

  onFileSelected(file: File): void {
    if (file) {
      this.selectedFile = file;
      this.store.dispatch(new ResetState());
    } else {
      this.selectedFile = null;
    }
  }

  onDownloadTemplate(): void {
    this.genericService.downloadTemplate(this.fields, this.templateFilename);
  }

  onValidate(): void {
    if (this.selectedFile) {
      this.store.dispatch(new ValidateFile({ file: this.selectedFile, endpointUrl: this.validateEndpoint }));
    }
  }

  onShowConfirmModal(): void {
    this.showConfirmModal = true;
  }

  onConfirmUpload(): void {
    this.showConfirmModal = false;
    if (this.selectedFile) {
      this.store.dispatch(new UploadFile({ file: this.selectedFile, endpointUrl: this.uploadEndpoint }));
    }
  }

  onCancelUpload(): void {
    this.showConfirmModal = false;
  }

  onReset(): void {
    this.selectedFile = null;
    this.store.dispatch(new ResetState());
  }
}
